// extracted by mini-css-extract-plugin
export default {"main-content":"MyProfile_main-content__0sXM6","main-content__user-profile":"MyProfile_main-content__user-profile__gJ9SN","button":"MyProfile_button__OqSxZ"};